import React from 'react';
import { forwardRef, Button as ChakraButton } from '@chakra-ui/react';

const Button = forwardRef(({ children, ...rest }, ref) => (
  <ChakraButton
    ref={ref}
    borderRadius="2.3vw"
    height={{ base: '11vw', lg: '7vw' }}
    backgroundColor="white"
    color="black"
    fontWeight="medium"
    fontSize={{ base: '4.16vw', lg: '3vw' }}
    textTransform="uppercase"
    bg="white"
    border="1px solid"
    borderColor="white"
    transition="none"
    _hover={{
      bg: 'black',
      color: 'white',
    }}
    {...rest}
  >
    {children}
  </ChakraButton>
));
export default Button;
